<template>
  <div style="min-height: 100vh; position: relative">
    <div
      v-if="!selectedBot.status"
      style="
        position: absolute;
        z-index: 2;
        background-color: #ecececbd;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      "
    >
      <div class="text-xs-center mt-5 pt-5" style="margin-bottom: 25px">
        <v-card max-width="600" style="margin: auto">
          <v-card-text>
            <h3 style="text-shadow: 1px 1px 20px #9e9e9e" class="display-1">
              {{ $t('If you want to test, please activate your bot') }}
            </h3>
            <p>
              {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
            </p>

            <v-btn
              depressed
              style="margin-bottom: 1.5em"
              small
              color="primary"
              @click="toggleBotStatus"
              >{{ $t('Click for starting your Bot') }}</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-container fluid>
      <div v-if="isTcpMainPage">
        <v-layout wrap>
          <v-flex xs12 sm6 class="py-3">
            <multiselect
              v-model="filterTcpPage"
              :options="tcpPageOptions"
              select-label
              selected-label
              placeholder="เลือกเพจ"
              label="page_name"
              style="margin-bottom: 4px"
              @input="getIntent"
            ></multiselect>
          </v-flex>
        </v-layout>
      </div>
      <div
        v-if="['studio7', 'ticket2'].includes(selectedBot.theme)"
        style="width: 40%"
        class="mb-3"
      >
        <multiselect
          v-model="selectedCom7page"
          :options="$store.state.com7pages"
          :allow-empty="false"
          :show-labels="false"
          :searchable="false"
          label="name"
          @input="getIntent"
        >
        </multiselect>
        <!-- [{ name: 'All', pageid: null }, ...$store.state.com7pages] -->
      </div>
      <v-layout wrap>
        <v-flex
          v-if="
            !['105911105134578', '101931352240400', ...$store.state.pageListSingGaling].includes(
              selectedBot.pageid
            )
          "
          xs12
          sm9
        >
          <DashboardSelectChannel v-model="filter" @changeChannel="getIntent" />
        </v-flex>
        <v-flex v-else xs12 sm9> </v-flex>
        <v-flex xs12 sm3 class="text-sm-right">
          <template v-if="selectedBot.pageid == '109179590915799'">
            <v-btn
              v-if="$store.getters.getPackage != 'premium'"
              v-tooltip.top="'Unlock to PREMIUM plan'"
              outline
              color="grey"
              class="ma-0 mb-1"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }} Thai Union
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else
              color="primary"
              outline
              class="ma-0 mb-1"
              :loading="loadingThaiUnion"
              @click="getchatlogthaiunionformat"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }} Thai Union
            </v-btn>
          </template>
          <template v-if="loading">
            <v-btn :loading="true" color="grey" outline class="ma-0 mb-1"></v-btn>
          </template>
          <template v-else>
            <v-btn
              v-if="$store.getters.getPackage != 'premium' || isCoachlab"
              v-tooltip.top="'Unlock to PREMIUM plan'"
              outline
              color="grey"
              class="ma-0 mb-1"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
              <v-premium-lock></v-premium-lock>
            </v-btn>
            <v-btn
              v-else-if="$store.getters.getPackage == 'premium'"
              color="grey"
              outline
              class="ma-0 mb-1"
              @click="exportDashboard"
            >
              <em class="fas fa-file-export mr-1" />
              {{ $t('export') }}
            </v-btn>
          </template>
        </v-flex>
      </v-layout>

      <date-filter v-model="selectedDate" @onSelected="getIntent"></date-filter>

      <h3 class="title">{{ $t('Conversation') }}</h3>
      <v-layout wrap>
        <v-flex xs12 sm12 md12>
          <div class="pa-1">
            <v-card>
              <v-card-title>
                <v-layout>
                  <v-flex>{{ $t('Conversation') }}</v-flex>
                  <v-flex class="text-xs-right">
                    <!-- <v-btn small outline color="primary">{{$t('Export')}}</v-btn> -->
                  </v-flex>
                </v-layout>
              </v-card-title>

              <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>

              <div style="max-width: 350px; margin: auto">
                <apexchart
                  v-if="intentSeries && intentSeries.length > 0"
                  :key="apexkey"
                  ref="intent"
                  type="pie"
                  :options="intentGraph"
                  :series="intentSeries"
                  style="margin: auto"
                ></apexchart>
              </div>
              <v-divider></v-divider>
              <v-data-table
                :pagination.sync="pagination"
                :headers="intentHeaders"
                :items="intentChartData"
                :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
                :rows-per-page-text="$t('Rows per page')"
              >
                <template #items="props">
                  <td>
                    <v-avatar :color="props.item.color" size="15"></v-avatar>
                  </td>
                  <td>
                    {{ intentLabel(props.item.name) }}
                  </td>
                  <td>{{ props.item.value | numberFormat }}</td>
                  <td>
                    <v-btn
                      fab
                      icon
                      small
                      flat
                      color="grey"
                      @click="openIntentDetail(props.item.name)"
                    >
                      <v-icon>search</v-icon>
                    </v-btn>
                  </td>
                </template>

                <template slot="no-data">
                  <div class="text-xs-center">{{ $t('No conversation') }}</div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-flex>
      </v-layout>

      <v-dialog v-if="currentIntent" v-model="showIntent" scrollable>
        <v-card>
          <v-card-title>
            {{ intentLabel(currentIntent) }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 300px" class="pa-0">
            <div v-if="loadingIntent">
              <div style="padding: 30px 0">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                ></scale-loader>
              </div>
            </div>
            <div v-else-if="filterIntentDetail.length <= 0">
              <div class="text-xs-center" style="margin: 35px 0">
                <img src="/static/img/assets/setting/conversation.png" alt style="width: 230px" />
                <h3>{{ $t('Not found any chatlog') }}</h3>
                <!-- <p>test</p> -->
              </div>
            </div>
            <div v-else>
              <template v-if="intentDetails && intentDetails.length">
                <v-data-table :headers="modalIntentHeader" :items="intentDetails" hide-actions>
                  <template #items="props">
                    <!-- <td>{{ props.item.name }}</td> -->
                    <td style="word-break: break-word">
                      {{ props.item.questiondata ? props.item.questiondata : $t('Other') }}
                    </td>
                    <td class="text-xs-center">{{ props.item.count | numberFormat }}</td>
                  </template>
                </v-data-table>

                <div v-if="$store.getters.getPackage != 'premium'" class="text-xs-center mt-5 mb-3">
                  <h3 class="headline" style="text-shadow: 1px 1px 20px #9e9e9e">
                    {{ $t('Its time to upgrade.') }}
                  </h3>
                  <p style="text-shadow: 1px 1px 20px #9e9e9e">
                    {{ $t('Upgrade Your Plan to use PREMIUM features , only 500 THB/month') }}
                  </p>
                  <v-btn
                    v-if="selectedBot.pagetype != 'enterprise'"
                    depressed
                    color="primary"
                    :to="'/' + $i18n.locale() + '/upgrade'"
                    >{{ $t('Upgrade to Premium Plan') }}</v-btn
                  >
                </div>
              </template>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outline color="grey" @click="showIntent = false">{{ $t('cancel') }}</v-btn>
            <v-btn
              v-if="currentIntent == '{default}'"
              depressed
              color="primary"
              :to="trainingUrl"
              >{{ $t('Training') }}</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'
import VueApexCharts from 'vue-apexcharts'
import multiselect from 'vue-multiselect'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import DashboardGraphLoading from './DashboardGraphLoading'
import DateFilter from './DateFilter'
import DashboardSelectChannel from './DashboardSelectChannel'
import { PAGE } from '@/constants/page.js'

export default {
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    DateFilter,
    ScaleLoader,
    multiselect,
    DashboardSelectChannel
  },
  data: function () {
    return {
      selectedCom7page: {
        pageid: null,
        name: ''
      },
      apexkey: 1,
      loading: true,
      loadingThaiUnion: false,
      loadingIntent: true,
      showIntent: false,
      filter: 'all',
      selectedDate: {
        start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      currentIntent: undefined,
      currentIntentIndex: undefined,
      intentDetails: [],
      intentChartData: [],
      intentChart: undefined,
      modalIntentHeader: [
        { text: this.$t('customer says'), value: 'questiondata' },
        { text: this.$t('Count'), value: 'count', align: 'center' }
      ],
      intentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      commentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentPagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentChartData: [],

      intentSeries: [100],
      commentSeries: [],
      intent: {
        labels: [],
        intentname: [],
        colors: [],
        count: []
      },

      intentGraph: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      },
      comment: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      },
      maxGraph: 500,
      filterTcpPage: ''
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab'
    }),

    filterIntentDetail: function () {
      var vm = this
      return vm.intentDetails.sort(function (a, b) {
        if (a.training == true && b.training != true) {
          return 1
        }
        if (a.training != true && b.training == true) {
          return -1
        }

        return 0
      })
    },
    trainingUrl: function () {
      return (
        '/' +
        this.currentLang +
        '/training?datefrom=' +
        moment(this.selectedDate.start).format('YYYY-MM-DD') +
        '&dateto=' +
        moment(this.selectedDate.end).format('YYYY-MM-DD')
      )
    },
    tcpPageOptions() {
      return this.$store.state.tcpSubpages || []
    },
    isTcpMainPage() {
      return PAGE.TCP_MAIN_PAGE.includes(this.selectedBot.pageid)
    }
  },
  mounted: function () {
    if (['studio7', 'ticket2'].includes(this.selectedBot.theme)) {
      let com7page = this.$store.state.com7pages.find((f) => f.pageid == this.selectedBot.pageid)
      this.selectedCom7page.name = com7page.name
    }

    if (this.isTcpMainPage && !this.$store.state.tcpSubpages) {
      this.$store.dispatch('getTcpSubpages')
    }

    if (this.selectedBot.status) this.getIntent()
    else {
      this.loadingIntent = false
      this.loading = false
    }
  },
  methods: {
    getchatlogthaiunionformat() {
      var vm = this
      //thai union
      this.loadingThaiUnion = true
      api.getchatlogthaiunionformat(
        {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD')
        },
        function (error, response) {
          if (error) {
            console.error(error)
            vm.loadingThaiUnion = false
            return
          }
          // console.log(response)
          if (response.responsecode == 200) {
            var json = []
            json = response.data.flatMap((el) => {
              if (el.answerby == 'admin') {
                return [
                  {
                    Sender: el.answerby,
                    'facebook - line Name': el.facebookname,
                    empcode: el.empcode,
                    'User MessageType': el.messagetype,
                    'User Message': el.messagedata,
                    timestampDate: moment(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: moment(el.timestamp).format('HH:mm')
                  }
                ]
              } else {
                return [
                  {
                    Sender: 'customer',
                    'facebook - line Name': el.facebookname,
                    empcode: el.empcode,
                    'User MessageType': el.questiontype,
                    'User Message': el.questiondata,
                    timestampDate: moment(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: moment(el.timestamp).format('HH:mm')
                  },
                  {
                    Sender: el.answerby,
                    'facebook - line Name': 'Thai Union HR People Connect',
                    empcode: '',
                    'User MessageType': el.messagetype,
                    'User Message': el.messagedata,
                    timestampDate: moment(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: moment(el.timestamp).format('HH:mm')
                  }
                ]
              }
            })

            const dataWS = XLSX.utils.json_to_sheet(json)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwizdata-thaiunion-conversation.xlsx')
          }
          vm.loadingThaiUnion = false
        }
      )
    },
    getIntent: function () {
      const vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        datefrom: moment(vm.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(vm.selectedDate.end).format('YYYY-MM-DD')
      }

      if (vm.filter !== 'all') {
        Object.assign(data, { app: vm.filter })
      }

      if (vm.isTcpMainPage) {
        data.pageid = vm.filterTcpPage ? vm.filterTcpPage.page_id : vm.selectedBot.pageid
        Object.assign(data, {
          tcp_master_page_id: vm.selectedBot.pageid
        })
      }

      vm.loading = true

      let selectedApi = 'getDashboardIntent'
      if (['studio7', 'ticket2'].includes(vm.selectedBot.theme)) {
        selectedApi = 'getcom7pagereport_intents'
        data.pageid = vm.selectedCom7page.pageid
          ? vm.selectedCom7page.pageid
          : vm.selectedBot.pageid
      }

      api[selectedApi](data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        if (response.data) {
          let sortedData = response.data.sort(vm.sortIntent)
          let conversations = {
            data: [],
            label: [],
            graph_label: [],
            color: [],
            intentname: [],
            intents: []
          }

          sortedData.forEach((val) => {
            let current_color = vm.getRandomColor()
            if (val['messagetype'] == 'inbox') {
              if (val['intent'] === '{default}') {
                let intent = {}
                intent.name = val['intent']
                conversations.intentname.unshift(val['intent'])
                conversations.label.unshift(vm.$t('Default Conversation'))
                conversations.graph_label.unshift(vm.$t('Default Conversation'))
                conversations.data.unshift(parseInt(val['count']))
                conversations.color.unshift(current_color)

                intent.color = current_color
                intent.value = parseInt(val['count'])

                conversations.intents.unshift(intent)
              } else {
                let intent = {}
                conversations.label.push(vm.intentLabel(val['intent']))
                conversations.graph_label.push(
                  vm.$options.filters.truncate(vm.intentLabel(val['intent']), 20)
                )
                intent.name = val['intent']
                conversations.intentname.push(val['intent'])
                conversations.data.push(parseInt(val['count']))
                conversations.color.push(current_color)

                intent.color = current_color
                intent.value = parseInt(val['count'])

                conversations.intents.push(intent)
              }
            }
          })
          vm.intentSeries = []
          vm.intent = {
            ...vm.intent,
            labels: conversations.label,
            intentname: conversations.intentname,
            colors: conversations.color,
            count: conversations.data
          }

          vm.intentGraph = {
            ...vm.intentGraph,
            labels: vm.slice(conversations.graph_label, 0, vm.maxGraph),
            intentname: vm.slice(conversations.intentname, 0, vm.maxGraph),
            colors: vm.slice(conversations.color, 0, vm.maxGraph)
          }

          const topConversation = vm.slice(conversations.data, 0, vm.maxGraph)

          topConversation.forEach((data) => {
            vm.intentSeries.push(data)
          })
          const lastConversation = vm.slice(
            conversations.data,
            vm.maxGraph,
            conversations.data.length - vm.maxGraph
          )

          if (lastConversation.length > 0) {
            const otherConversation = lastConversation.reduce((prev, curr) => prev + curr, 0)
            vm.intentSeries.push(otherConversation)

            vm.intentGraph.labels.push(vm.$t('Others'))
            vm.intentGraph.intentname.push('Others')
            vm.intentGraph.colors.push('#eeeeee')
          }

          vm.intentChartData = conversations.intents

          vm.$nextTick(function () {
            if (vm.$refs.intent) {
              vm.$refs.intent.updateOptions({
                colors: conversations.color,
                labels: conversations.graph_label
              })
            }

            vm.apexkey++
            vm.loading = false
          })
        }
      })
    },
    getRandomColor: function () {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    truncate: function (text, limit) {
      let length = text.length
      return text.substring(0, Math.min(limit, length)) + (length > limit ? '...' : '')
    },
    sortIntent: function (a, b) {
      // console.log(a.count)
      if (parseInt(a.count) < parseInt(b.count)) return 1
      if (parseInt(a.count) > parseInt(b.count)) return -1
      return 0
    },
    getTrainingConversation: function () {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.currentIntent,

        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        app: this.filter
      }
      vm.loadingIntent = true
      api.getGroupDefaultChatlogs(data, function (error, response) {
        if (error) {
          console.error(error)
          vm.loadingIntent = false
          return
        }
        if (response.data) {
          vm.intentDetails = response.data
        }
        vm.loadingIntent = false
      })
    },
    openIntentDetail: function (intentName) {
      var vm = this
      vm.currentIntent = intentName
      vm.loadingIntent = true
      vm.getTrainingConversation()
      vm.showIntent = true
    },
    exportDashboard: function () {
      const vm = this
      try {
        if (vm.loading) {
          return false
        }
        this.loading = true
        let json = []
        json.push([
          `${this.$t('from')} ` +
            moment(vm.selectedDate.start).format('DD/MM/YYYY') +
            ` ${this.$t('to')} ` +
            moment(vm.selectedDate.end).format('DD/MM/YYYY')
        ])

        if (vm.isTcpMainPage || vm.isTcpSubpage) {
          json.push([
            'Page',
            vm.filterTcpPage ? vm.filterTcpPage.page_name : vm.selectedBot.pagename
          ])
        } else {
          json.push([])
        }

        json.push([this.$t('Conversation')])
        json.push(['Name', 'Count', 'Percent'])

        const totalIntentMessage = vm.intent.count.reduce((prev, curr) => {
          prev += curr
          return prev
        }, 0)

        vm.intent.labels.forEach(function (seriesData, index) {
          json.push([
            seriesData,
            numeral(vm.intent.count[index]).format('0,0'),
            (totalIntentMessage > 0
              ? numeral((vm.intent.count[index] * 100) / totalIntentMessage).format('0.00')
              : 0) + ' %'
          ])
        })
        json.push([])
        json.push([])
        json.push([this.$t('Reply to inbox')])
        json.push(['Name', 'Count', 'Percent'])

        var totalCommentMessage = 0
        vm.comment.labels.forEach(function (seriesData, index) {
          totalCommentMessage += vm.commentSeries[index]
        })

        vm.comment.labels.forEach(function (seriesData, index) {
          json.push([
            seriesData,
            numeral(vm.commentSeries[index]).format('0,0'),
            (totalCommentMessage > 0
              ? numeral((vm.commentSeries[index] * 100) / totalCommentMessage).format('0.0')
              : 0) + ' %'
          ])
        })

        const dataWS = XLSX.utils.aoa_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'zwizdata-summary-conversation.xlsx')
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },
    toggleBotStatus: async function () {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/SummaryIntent.vue